const ClaimsSkeletonLoader = () => {
  return (
    <div className="animate-pulse overflow-x-auto">
      <table className="min-w-full table-fixed border-collapse">
        <thead>
          <tr>
            {/* 1.3.1 Info and Relationships — A: <th> requires a scope so assistive tech
                can associate it with the cells it heads. */}
            <th
              scope="colgroup"
              colSpan={5}
              className="w-full bg-gray-100 py-3 text-center text-lg font-semibold"
            >
              <div className="mx-auto h-4 w-24 rounded bg-gray-300" />
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: 4 }).map((_, idx) => (
            <tr key={idx} className="align-top">
              {/* Date */}
              <td className="w-[10%] px-2 py-4">
                <div className="mb-2 h-4 w-10 rounded bg-gray-300" />
                <div className="h-4 w-8 rounded bg-gray-300" />
              </td>
              {/* Name & Details */}
              <td className="w-[35%] px-2 py-4">
                <div className="mb-2 h-4 w-24 rounded bg-gray-300" />
                <div className="mb-1 h-4 w-32 rounded bg-gray-300" />
                <div className="mb-1 h-4 w-40 rounded bg-gray-300" />
                <div className="h-4 w-28 rounded bg-gray-300" />
              </td>
              {/* Mapview Availability */}
              <td className="w-[35%] px-2 py-4 align-bottom">
                <div className="mt-16 h-4 w-36 rounded bg-gray-300" />
              </td>
              {/* Member Responsibility */}
              <td className="w-[30%] px-2 py-4 text-right">
                <div className="mb-2 ml-auto h-4 w-40 rounded bg-gray-300" />
                <div className="ml-auto h-5 w-16 rounded bg-gray-300" />
              </td>
              {/* Arrow & Status */}
              <td className="w-[10%] px-2 py-4 text-left">
                <div className="flex items-center gap-2">
                  <div className="size-4 rounded-full bg-gray-300" />
                  <div className="h-6 w-12 rounded-full bg-gray-300" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClaimsSkeletonLoader;
